/*
 * Model for getting monetary unit data
 */
angular.module('taric.model.monetaryunits', ['ngResource', 'common.config']).factory('MonetaryUnits', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/moun/monetaryUnits', {}, {
        queryMonetaryUnits: {
            method: 'GET',
            isArray: false
        }
    });
}).service('MonetaryUnitsModel', function ($q, MonetaryUnits, CommonHelper) {
    var model = this;

    model.customsValueMonetaryUnits = function (simulationDate) {
        var deferred = $q.defer();
        MonetaryUnits.queryMonetaryUnits({
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            type: "C"
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
    model.dutyMonetaryUnits = function (simulationDate) {
        var deferred = $q.defer();
        MonetaryUnits.queryMonetaryUnits({
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            type: "D"
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };
});



// WEBPACK FOOTER //
// ./app/common/model/taric/monetary-units-model.js